var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgValidacaoVerde(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_124",
    "data-name": "Caminho 124",
    d: "M44,32A12,12,0,1,0,56,44,12,12,0,0,0,44,32Zm6.155,7.987L42.7,49.55c-.059.059-.155.188-.273.188a.394.394,0,0,1-.273-.155c-.07-.07-4.227-4.066-4.227-4.066l-.08-.08a.279.279,0,0,1,0-.343.7.7,0,0,0,.059-.064c.412-.434,1.248-1.312,1.3-1.366.07-.07.129-.161.257-.161s.22.112.284.177S42.163,46,42.163,46l5.962-7.661a.306.306,0,0,1,.188-.075.3.3,0,0,1,.188.07l1.639,1.291a.3.3,0,0,1,.07.188A.278.278,0,0,1,50.155,39.987Z",
    transform: "translate(-32 -32)",
    fill: "#009738"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidacaoVerde);
export default __webpack_public_path__ + "static/media/validacao-verde.64cc3eb1d90dabf5323447bee11a1044.svg";
export { ForwardRef as ReactComponent };